<template>
  <div>
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        그룹
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">그룹</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
          <b-tab title="정보" border-variant="primary" >
            <b-card>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title mr-auto">
                  그룹 정보
                </div>
                <div class="mb7">
                  <span class="float-right">{{model.joined_at | sdate}}</span>
                </div>
              </div>
              <hr>
              <b-row class="mb-2">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_name">
                    그룹 이름
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <b-form-input type="text" v-if="lock" :value="model.groupname" plaintext></b-form-input>
                  <b-form-input v-else md=12 type="text" id="ph_name" v-model="model.groupname" :disabled="lock"></b-form-input>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_service">
                    서비스
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <v-select :readonly="true" @input="set_service" v-if="!lock || !model.service_name" label="service_name" v-model="model.service" :options="partner_service"></v-select>
                  <label v-else-if="model.service.id == null">{{model.service}}</label>
                  <h4 v-else>
                    <b-badge  :variant="model.service_name === 'Basic' ? 'info' : 'success'"> {{model.service_name}}</b-badge>
                  </h4>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label mr-2" label-for="ph_credit">
                    청구
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <span class="label_sub">
                    $ {{model.credit | number}}
                  </span>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label mr-2" label-for="ph_count">
                    회원 수
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
                  <span class="label_sub">
                    {{model.count | number}}
                  </span>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2">
                  <b-row>
                    <div class="col-xl-12 col-md-12 d-flex align-self-center">
                      <label class="col-form-label">
                        사용하는 보안 설정
                        (<b-button variant="link" @click="index = 3" class="px-0">설치 이력</b-button>)
                      </label>
                    </div>
                  </b-row>
                </b-col>
                <b-col class="col-xl-10">
                  <b-row>
                    <b-col class="col-xl-12 col-md-12 mb-2">
                      <b-badge class="mt-4" variant="danger">WebCastle : {{model.info.wc_count}} </b-badge>
                      <b-badge class="mt-4" variant="warning">WSFinder : {{model.info.wsf_count}} </b-badge>
                      <b-badge class="mt-4" variant="success">WMDS : {{model.info.wmds_count}} </b-badge>
                      <b-badge class="mt-4" variant="info">WFDetector : {{model.info.wf_count}} </b-badge>
                    </b-col>
                    <b-col class="col-xl-12 col-md-12 d-flex flex-wrap">
                      <b-row class="text-center">
                        <div class="col-xl-12 col-md-12 d-flex flex-wrap">
                          <div class="row  text-center">
                            <div class="col-xl-2">
                              <label class="col-form-label " for="Invoice11"  v-b-tooltip.hover title="발행된 청구서 발송 여부를 설정합니다. '소유자' 계정만 설정할 수 있습니다.">
                                청구서 발송
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Invoice11" id="Invoice11" v-model="model.allow_invoice" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Active" v-b-tooltip.hover title="보안 설정을 활성화해요">
                                활성화
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Active" id="Active"  v-model="model.is_alive" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Mail" v-b-tooltip.hover title="공지 알림 메일 허용(탐지, QNA, Notice, etc...)">
                                메일
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Mail" id="Mail" v-model="model.allow_mail" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label class="col-form-label" for="Single_login">
                                단일 로그인
                              </label>
                              <div class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Single_login" id="Single_login" v-model="model.single_login" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-xl-2">
                              <label v-if="model.is_del" class="col-form-label" for="Delete">
                                삭제
                              </label>
                              <div v-if="model.is_del" class="checkbox-switch">
                                <input type="checkbox" class="input-checkbox" name="Delete" id="Delete" v-model="model.is_del" :disabled="lock">
                                <div class="checkbox-animate">
                                  <span class="checkbox-off">OFF</span>
                                  <span class="checkbox-on">ON</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_email">
                    이메일
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.email" plaintext></b-form-input>
                  <b-form-input type="text" v-else id="ph_email" v-model="model.email" :disabled="lock"></b-form-input>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center" for="ph_contact">
                  <label class="col-form-label" for="ph_contact">
                    컨택트
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.contact" plaintext></b-form-input>
                  <b-form-input type="text" v-else id="ph_contact" v-model="model.contact" :disabled="lock"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="Address">
                    주소
                  </label>
                  <span class="text-danger ml-1">*</span>
                </b-col>
                <b-col class="col-xl-10 col-md-12">
                  <b-form-input type="text" v-if="lock" :value="model.address" plaintext></b-form-input>
                  <b-form-input md=12 type="text" v-else id="group_address" v-model="model.address" :disabled="lock"></b-form-input>
                </b-col>
              </b-row>
              <br>
              <div class="d-flex flex-wrap align-items-center">
                <div class="title_sub">
                  지역
                </div>
              </div>
              <hr>
              <b-row class="mb-2">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_country_group">
                    국가
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_country" :disabled="lock" label="name" v-model="region.country">
                    <option v-for="(item, index) in codes.country" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_language_group">
                    언어
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_language" :disabled="lock" label="name" v-model="region.language">
                    <option v-for="(item, index) in codes.language" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_timezone_group">
                    시간대
                    <span class="text-danger ml-1">*</span>
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <select class="form-control" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone">
                    <option v-for="(item, index) in codes.timezone" :key="index" :value="item">{{item.name}}</option>
                  </select>
                </b-col>
              </b-row>
              <b-row class="mb-2 mt-3">
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_syslog" v-b-tooltip.hover title="서버 IP 로그생성/관리를 입력하세요, ex) 192.168.0.100, 192.168.0.0/24 ">
                    시스템 로그
                  </label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-textarea ref="syslog_list" :rows="model && model.syslog ? model.syslog.length + 2 : 0" max-rows="10" v-model="model.syslog_list" :plaintext="lock"></b-form-textarea>
                </b-col>
                <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
                  <label class="col-form-label" for="ph_mail_cc" v-b-tooltip.hover title="경고 감지를 받을 이메일 참조 주소를 입력하세요.">이메일 참조</label>
                </b-col>
                <b-col class="col-xl-4 col-md-12">
                  <b-form-textarea ref="email_cc_list" :rows="model && model.mail_cc ? model.mail_cc.length + 2 : 0" max-rows="10" v-model="model.email_cc_list" :plaintext="lock"></b-form-textarea>
                </b-col>
              </b-row>
              <div class="mt-4">
                <b-button :disabled="model.is_del" v-if="!lock" size="sm" class="btn btn-add" @click="save"> 저장 </b-button>
                <b-button :disabled="model.is_del" v-else size="sm" variant="warning" @click="edit">
                  {{ model.is_del  ? '이미 삭제된 정보입니다.' : '편집'}}
                </b-button>
                <b-button :disabled="model.is_del" v-if="!lock" size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
                <b-button :disabled="model.is_del" size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock && !model.is_del"> 삭제 </b-button>
                <b-button :disabled="model.is_del" size="sm" class="btn btn-addition" @click="send_ip_reset_mail" v-if="model.id && !model.is_del && lock"> IP ACL 재설정 메일 보내기 </b-button>
                <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
              </div>
            </b-card>
            <b-card v-if="model.partner_id && model.partner && !model.partner.is_del" >
              <partner-Detail :partner="model.partner"></partner-Detail>
            </b-card>
          </b-tab>
          <!-- start group's user -->
          <b-tab title="사용자 목록" border-variant="primary" :disabled="$route.params.id == 'add'">
            <b-card>
              <!-- start group's user -->
              <user-list v-if="model.id" :group="model" :view_detail="false"/>
            </b-card>
          </b-tab>
          <!-- end group's user -->

          <!-- start group's security_policy -->
          <b-tab title="보안 정책" border-variant="primary" :disabled="$route.params.id == 'add'">
            <security-policy v-if="model.id" :group="model"/>
          </b-tab>
          <!-- end group's security_policy -->

          <!-- start group's user -->
          <!-- <b-tab title="WSFinder" border-variant="primary" >
            <wsfinder-list v-if="model.id && model.service != 'Basic'" :group="model" :delay="2"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WMDS" border-variant="primary" >
            <wmds-list v-if="model.id" :group="model" :delay="3"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's user -->
          <!-- <b-tab title="WebCastle" border-variant="primary" >
            <webcastle-list v-if="model.id" :group="model" :delay="4"/>
          </b-tab> -->
          <!-- end group's user -->

          <!-- start group's install history -->
          <b-tab title="설치 이력" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <InstallHistoryList v-if="model.id" ref="install_history" :user="model" />
            </b-card>
          </b-tab>
          <!-- end group's install history -->
          <!-- start group's Invoice -->
          <b-tab title="청구서" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <!-- ss -->
              <InvoiceHistoryList v-if="model.id" :group_id="model.id" ref="_list_invoice" />
              <hr>
              <b-button size="sm" class="pull-right" variant="primary" @click="confirm_ticket_invoice = true;" v-if="model.id"> 청구서 발급 </b-button>
            </b-card>
          </b-tab>
          <!-- end group's Invoice -->
          <!-- start group's Invoice -->
          <b-tab title="QNA" :disabled="$route.params.id == 'add'" @click="() => $refs._install_history ? $refs._install_history.refresh() : ''">
            <b-card>
              <!-- user == group -->
              <QNAList v-if="model.id" :group="model" :only_view="true" />
            </b-card>
          </b-tab>
          <!-- end group's Invoice -->
        </b-tabs>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <b-modal title="삭제 안내"  class="modal-danger" header-bg-variant="danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      그룹 내에 사용자가 있을 경우 삭제가 불가능해요.
      <br>
      삭제시 현재 이용하고 있는 구독 정보가 사라져요.
      <br>
      그룹을 삭제할까요?
    </b-modal>
    <!-- 인보이스 발급 년월 선택 -->
    <b-modal title="청구서 발행"  class="modal-dark" v-model="confirm_ticket_invoice" @ok="ticket_invoice" ok-variant="outline-primary" ok-title="확인" cancel-title="취소" cancel-variant="outline-dark">
      <b-form-group>
        <p>청구서 발행 월을 선택하십시오</p>
        <hr>
        <!-- <vue-monthly-picker selectedBackgroundColor="blue" alignment="center" dateFormat="YYYY-MM" style="width: 100%;" v-model="ticket_invoice_month"> </vue-monthly-picker> -->
        <date-picker style="width: 100%;" type="month" v-model="ticket_invoice_month" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
        <hr>
        <small class="text-danger font-weight-bold">
          이미 발급된 경우 강제로 발급합니다.
          <br>
          생성된 청구서의 금액을 확인하세요.
          <br>
          청구서가 발행되면 안내 메일이 발송됩니다
        </small>
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>